export default "__VITE_ASSET__ba38b272__"